import { render, staticRenderFns } from "./GiftAidCheckbox.vue?vue&type=template&id=580532d4&scoped=true&"
import script from "./GiftAidCheckbox.vue?vue&type=script&lang=ts&"
export * from "./GiftAidCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./GiftAidCheckbox.vue?vue&type=style&index=0&id=580532d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580532d4",
  null
  
)

export default component.exports